// Utilitaires SEO : génération de slugs propres et construction d'URLs
// ville / quartier / spécialité du type /rabat/agdal/cardiologue.

export const CITY_NAME = 'Rabat';
export const CITY_SLUG = 'rabat';

// Transforme un libellé en slug : accents, apostrophes et espaces nettoyés.
export function slugify(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Retrouve le libellé canonique correspondant à un slug (ou undefined).
export function findByNameSlug(list: string[], slug?: string): string | undefined {
  if (!slug) return undefined;
  const target = slug.toLowerCase();
  return list.find((item) => slugify(item) === target);
}

// Construit une URL propre à partir du quartier et de la spécialité.
// - quartier seul        -> /rabat/agdal
// - quartier + spécialité -> /rabat/agdal/cardiologue
// - sans quartier        -> /recherche (la spécialité repasse en paramètre)
export function buildSearchPath(district: string, specialty?: string): string {
  if (!district) return '/recherche';
  const segments = [CITY_SLUG, slugify(district)];
  if (specialty) segments.push(slugify(specialty));
  return `/${segments.join('/')}`;
}